import { createContext, useContext } from 'react';

export type PlanOperationConfig = {
  planUpdateEnabled: boolean;
};

export const PlanOperationConfigContext = createContext({
  planUpdateEnabled: true,
});

export const usePlanOperationConfig = (): PlanOperationConfig => {
  return useContext(PlanOperationConfigContext);
};
